export class Environments {
	public id: string | undefined;
	public name: string;
}
